import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/** Eticheta de secțiune: majuscule mici, spațiate, în tonul cel mai stins. */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <Typography
      component="span"
      sx={(theme) => ({
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: theme.palette.weather.faint,
      })}
    >
      {children}
    </Typography>
  );
}
